import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { Link } from "react-router-dom";
import "../csscomponent/HeroSection.css";
import Lottie from "lottie-react";

let cachedHeroLottie = null;

function HeroSection() {
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const leftInView = useInView(leftRef, { once: true });
  const rightInView = useInView(rightRef, { once: true });
  const [animateData, setAnimateData] = useState(() => cachedHeroLottie);

  useEffect(() => {
    let mounted = true;
    if (cachedHeroLottie) return undefined;
    import('../lottose.json')
      .then((mod) => {
        cachedHeroLottie = mod.default;
        if (mounted) setAnimateData(mod.default);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="hero-section">
      <div className="hero-bg-text hero-bg-text-left" aria-hidden="true">
        *SERVICES AND DEVELOPER • 
      </div>
      <div className="hero-bg-text hero-bg-text-right" aria-hidden="true">
        *SERVICES AND DEVELOPER •
      </div>
      <div className="hero-content">
        <motion.div
          ref={leftRef}
          initial={{ x: -100, opacity: 0 }}
          animate={leftInView ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="hero-text"
        >
          <h1 className="hero-title">We Build Unique Websites That Grow Startups</h1>
          <p className="hero-subtitle">
            Join us we help your startup shine with sleek, high performance, conversion focused websites.
            From landing pages to full platforms, we do it all with style and strategy.
          </p>
          <Link to="/services#packages" className="hero-btn">View Packages</Link>
        </motion.div>

        <motion.div
          ref={rightRef}
          initial={{ x: 100, opacity: 0 }}
          animate={rightInView ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          className="hero-image"
        >
          {animateData ? <Lottie animationData={animateData} loop className="hero-lottie" /> : null}
        </motion.div>
      </div>
    </section>
  );
}

export default HeroSection;
